module.exports = __webpack_public_path__ + "img/bg-dark3-s.26cc40f9.png";